import { render, staticRenderFns } from "./CTABlog.vue?vue&type=template&id=22e6ddb7"
import script from "./CTABlog.vue?vue&type=script&lang=js"
export * from "./CTABlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports